import { useMemo } from 'react';

import { di } from 'react-magnetic-di';

import type {
	ExecutionContext,
	ExecutionContextBase,
} from '../../../../common/types/execution-context';
import { useViewType } from '../../../../controllers/issue-adjustments/hooks/use-view-type';

export const useEnrichedExecutionContext = ({
	executionContext,
}: {
	executionContext: ExecutionContextBase | null;
}): ExecutionContext | null => {
	di(useViewType);

	const viewType = useViewType();

	const enrichedExecutionContext = useMemo(() => {
		return executionContext && { ...executionContext, viewType };
	}, [executionContext, viewType]);

	return enrichedExecutionContext;
};
